export const useAccessToken = () => {
  const accessToken = sessionStorage.getItem("access_token");
  return { accessToken };
};
